import type { HekateDisplayField } from '@onshape/www-inertia';

/** A wrapper around a vue component to be shown as in a unified signup screen */
export default class UnifiedSignupScreenComponent {
  public readonly displayField: HekateDisplayField;
  public isRequired: boolean = true;

  constructor({
    displayField,
    isRequired,
  }: {
    displayField: HekateDisplayField;
    isRequired?: boolean;
  }) {
    this.displayField = displayField;
    this.isRequired = isRequired ?? true;
  }
}
